import http from 'util/http'

/** 获取藏经阁下面的分类 */
export function getCategory() {
  return http.get('/newxyrj/public/article/buddhisttopic/category', {
    to_show: 5,
  })
}
/**
 * 通过分类获取文章
 * @param {number} id 分类ID
 * @param {object} param0 分页
 * @param {object} param0.pageindex 页码
 * @param {object} param0.pagesize 页数
 * @param {number} sort 排序 0 | 1
 */
export function getList(
  id: number,
  { pageindex, pagesize = 10 }: { pageindex: number; pagesize?: number },
  sort?: number,
) {
  return http.get('/newxyrj/public/courseware/category/id', {
    category_id: id,
    pageindex,
    pagesize,
    sort,
  })
}

/**
 * 获取文章详情
 * @param {number} id 文章id
 */
export function getArticleDetail(id: number) {
  return http.get('/newxyrj/public/courseware/id', { courseware_id: id })
}
/**
 * 文章点赞
 * @param {number} id 回答id
 */
export function likeArticle(id: number) {
  return http.post('/newxyrj/public/courseware/praise', {
    courseware_id: id,
    type: 0,
  })
}
/**
 * 文章取消点赞
 * @param {number} id 回答id
 */
export function unLikeArticle(id: number) {
  return http.post('/newxyrj/public/courseware/praise', {
    courseware_id: id,
    type: 1,
  })
}
/**
 * 收藏
 * @param {number} id 课件id
 * @param {number} cid 收藏夹id
 * @param type 类型
 */
export function collect(cid: number, did: number, type) {
  return http.post('/newxyrj/public/courseware/collect', {
    collect_folder_id: cid,
    courseware_id: did,
    type,
  })
}
/**
 * 取消收藏
 * @param {number} id 课件id
 * @param {number} cid 收藏夹id
 * @param type 类型
 */
export function cancelFavorite(did: number, type) {
  return http.post('/newxyrj/public/courseware/collect', {
    courseware_id: did,
    type,
    operation: 1,
  })
}
/**
 * 猜你喜欢
 * @param {number} id 课件id
 */
export function guess(id: number) {
  return http.get('/newxyrj/public/courseware/guess/like', {
    courseware_id: id,
  })
}
/**
 * 相关课程
 * @param {number} id 文章id
 */
export function related(id: number) {
  return http.get('/newxyrj/public/courseware/related/list', {
    courseware_id: id,
  })
}
/**
 * 相关课程
 * @param {number} id 文章id
 */
export function downloadData(id: number) {
  return http.get('/newxyrj/public/courseware/statistical/download', {
    courseware_id: id,
  })
}
